import React, { FC } from 'react';
import { Field, FieldProps } from 'formik';
import { Select, FormControl, Box, Text, TextFieldSize, TextFieldAppearance } from '@bechtel/gds';
import { CommodityType } from '@bechtel/types';
import { t } from '@lingui/macro';

interface CommodityTypeListProps {
  commodityTypes?: CommodityType[];
}

const CommodityItem = ({ item }: { item: CommodityType }) => {
  return <Text>{item.name}</Text>;
};

export const CommodityTypes: FC<CommodityTypeListProps> = ({ commodityTypes }) => {
  return (
    <Field name="commodityType">
      {({ form }: FieldProps) => {
        return (
          <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
            <FormControl label={t`Commodity`}>
              <Select
                name="commodityType"
                size={TextFieldSize.LARGE}
                appearance={TextFieldAppearance.NORMAL}
                items={commodityTypes}
                itemComponent={CommodityItem}
                selectedComponent={CommodityItem}
                onSelectedItemChange={(changes: any) => {
                  form.setFieldValue('commodityType', changes.selectedItem.id);
                  form.setFieldValue('commodityList', []);
                }}
              />
            </FormControl>
          </Box>
        );
      }}
    </Field>
  );
};
